module.exports = __webpack_public_path__ + "img/eads.0781f8f6.png";